
import { Store } from '../store/index.js'
import _ from 'lodash'
import { Notify } from 'quasar'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('pages/Login.vue')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('pages/Logout.vue'),
    beforeEnter: (to, from, next) => {
      Store.dispatch('user/logout').then(() => { next({ path: '/' }) })
    }
  },
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    beforeEnter: (to, from, next) => {
      if (to.path === '/') {
        var clientId = Store.getters['user/effectiveClientId']
        next({ path: '/c/' + clientId, replace: false })
      } else {
        next()
      }
    },
    children: [
      {
        path: 'switch/',
        component: () => import('pages/SwitchClient.vue')
      },
      {
        path: 'user/',
        component: () => import('pages/User.vue')
      },
      {
        path: 'c/:clientId',
        name: 'client',
        component: () => import('pages/ClientHolder.vue'),
        beforeEnter: (to, from, next) => {
          var clientId = Store.getters['user/effectiveClientId'] // the current effective client ID
          if (to.path === '/c/' + clientId) { // if were only going to the exact /c/clientId page...
            next({ path: to.path + '/apps/grid', replace: false }) // then redirect to /c/clientId/apps
          } else {
            var matched = to.path.match('/c/([^/]+).*')
            if (matched && matched.length >= 2) {
              var requestedClientId = matched[1] // otherwise what client id is requested?
              if (requestedClientId !== clientId) { // is it different to the loaded one?
                Store.dispatch('user/requestSwitchClient', requestedClientId).then(() => { // if different, then request a switch
                  next() // then continue
                }).catch((err) => {
                  Notify.error(err) // uhoh!
                  Store.dispatch('user/logout').then(() => {
                    next({ path: '/' })
                  }) // no idea, just logout!
                })
              } else {
                next() // requested client path is the one we have loaded! - just go
              }
            } else {
              throw new Error('What now?')
            }
          }
        },
        children: [
          {
            path: 'apps/grid',
            name: 'apps-grid',
            component: () => import('pages/AppSummaryGrid.vue'),
            beforeEnter: (to, from, next) => {
              Store.dispatch('app/clearSelectedFeApp')
              next()
            },
            meta: {
              pageHelp: 'app-grid'
            }
          },
          {
            path: 'apps/',
            name: 'apps',
            component: () => import('pages/AppsList.vue'),
            beforeEnter: (to, from, next) => {
              // if we have auto transitioned from below. then auto transition off if there's only one place to
              var isAutoSelectingRoutes = _.get(to, 'query.auto', null) === 'y'
              var hasOnlyOneApp = _.get(Store, 'state.app.feApps.length') === 1

              if (isAutoSelectingRoutes && hasOnlyOneApp) {
                var clientId = Store.getters['user/effectiveClientId']
                next({ name: 'app', replace: false, params: { clientId: clientId, appId: Store.state.app.feApps[0].app.id }, query: { auto: 'y' } })
              } else {
                next()
              }
            }
          },
          {
            path: 'app/:appId',
            component: () => import('pages/App.vue'),
            name: 'app',
            beforeEnter: (to, from, next) => {
              console.info('Navigating To: ' + to.path)
              if (to.params.appId) {
                /* redirect to ./map if no app specific page set */
                var doNext = () => {
                  next()
                }
                if (to.path.endsWith('/app/' + to.params.appId) || to.path.endsWith('/app/' + to.params.appId + '/')) {
                  var clientId = Store.getters['user/effectiveClientId']
                  doNext = () => {
                    next({ name: 'entitylist', params: { clientId, appId: to.params.appId } })
                  }
                }

                var currentSelectedFeApp = _.get(Store, 'state.app.selectedFeApp.app.id')
                if (currentSelectedFeApp !== to.params.appId) {
                  Store.dispatch('app/selectFeApp', to.params.appId).then(() => {
                    doNext()
                  })
                } else {
                  doNext()
                }
              } else {
                Notify.error('No appId parameter')
                next('/')
              }
            },
            children: [
              {
                path: 'feed',
                name: 'feed',
                component: () => import('pages/SiteTimeline.vue')
              },
              {
                path: 'map',
                name: 'map',
                component: () => import('pages/Map.vue')
              },
              {
                path: 'log',
                name: 'sitelog',
                component: () => import('pages/SiteLogMain.vue')
              },
              {
                path: 'docs',
                name: 'docs',
                component: () => import('pages/Documents.vue')
              },
              {
                path: 'assets',
                name: 'entitylist',
                component: () => import('pages/EntityList.vue')
              },
              {
                path: 'devices',
                name: 'devicelist',
                component: () => import('pages/DeviceList.vue')
              },
              {
                path: 'places',
                name: 'places',
                component: () => import('pages/Locations.vue')
              },
              {
                path: 'network',
                name: 'networkList',
                component: () => import('pages/NetworkList.vue')
              },
              {
                path: 'network/asset/:assetId',
                name: 'network_asset_view',
                component: () => import('pages/NetworkAssetView.vue')
              },
              {
                path: 'network/new',
                name: 'newNetwork',
                component: () => import('pages/NewNetwork.vue')
              },
              {
                path: 'new-asset',
                name: 'newWizard',
                component: () => import('src/pages/NewAssetWizard.vue')
              },
              {
                path: 'asset-import',
                name: 'assetImport',
                meta: { pageHelp: 'import-asset-details' },
                component: () => import('pages/NewAssetImport.vue')
              },
              {
                path: 'new-device',
                name: 'newDevices',
                component: () => import('pages/NewDeviceImport.vue')
              },
              {
                path: 'device/:deviceId',
                name: 'DeviceView',
                component: () => import('pages/DeviceView.vue')
              },
              {
                path: 'entity/:entityId/configure',
                name: 'entity_config',
                component: () => import('pages/EntityConf.vue')
              },
              {
                path: 'reports/',
                name: 'site_reports',
                component: () => import('pages/SiteReports.vue')
              },
              {
                path: 'cfg/modules',
                name: 'app_conf_modules',
                component: () => import('pages/ConfModuleList.vue')
              },
              {
                path: 'cfg/module/:moduleId',
                name: 'app_conf_module',
                component: () => import('pages/ConfModule.vue')
              },
              {
                path: 'module/:moduleId',
                // name: 'module_base',
                component: () => import('pages/ModuleBase.vue'),
                beforeEnter: (to, from, next) => {
                  console.info(to.path + ' - beforeEnter')
                  Store.dispatch('app/selectModule', to.params.moduleId).then(() => {
                    next()
                  })
                },
                children: [
                  {
                    path: '',
                    name: 'module_index',
                    component: () => import('pages/ModuleIndex.vue')
                  },
                  {
                    // this expects a ?entityId=<abc123> parameter
                    path: 'reports',
                    name: 'module_reports',
                    component: () => import('pages/ModuleReports.vue')
                  },
                  {
                    path: 'reports/run/:reportKey',
                    name: 'module_reports_run',
                    component: () => import('pages/ModuleReportsRun.vue')
                  },
                  {
                    // this expects a ?entityId=<abc123> parameter
                    path: 'page/v1/:page',
                    name: 'module_dynpage_v1',
                    component: () => import('pages/ModuleDynPage.vue')
                  },
                  {
                    // this expects a ?entityId=<abc123> parameter
                    path: 'page/v2/:page',
                    name: 'module_dynpage_v2',
                    component: () => import('pages/ModuleDynPageV2.vue')
                  },
                  {
                    // in module uiPages: { ... } a page that has type "bespoke" will match here.
                    // the page param selects the actual page to use within DynamicPageLoader
                    path: 'page/d/:page',
                    name: 'module_dynpage_bespoke',
                    component: () => {
                      return import('pages/bespoke/DynamicPageLoader.vue')
                    }
                  }
                ]
              }
            ]
          },
          {
            path: 'conf/',
            name: 'conf_menu',
            component: () => import('pages/ConfMenu.vue')
          },
          {
            path: 'tools/export/',
            name: 'tools_export',
            component: () => import('pages/Export.vue')
          },
          {
            path: 'conf/users',
            name: 'conf_users',
            component: () => import('pages/ConfUserList.vue')
          }
        ]
      } // end /c/:asdf
    ],
    meta: {
      requiresAuth: true
    }
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
